export default __webpack_public_path__ + "static/media/ReportIcon-Computer-MS.088411ad.jpg";